export const economicActivities = [
  {
    code: 11111,
    label: 'Cultivo de arroz',
  },
  {
    code: 11112,
    label: 'Cultivo de trigo',
  },
  {
    code: 11119,
    label: 'Cultivo de cereales n.c.p., excepto los de uso forrajero',
  },
  {
    code: 11121,
    label: 'Cultivo de maíz',
  },
  {
    code: 11129,
    label: 'Cultivo de cereales de uso forrajero n.c.p.',
  },
  {
    code: 11130,
    label: 'Cultivo de pastos de uso forrajero',
  },
  {
    code: 11211,
    label: 'Cultivo de soja',
  },
  {
    code: 11291,
    label: 'Cultivo de girasol',
  },
  {
    code: 11299,
    label: 'Cultivo de oleaginosas n.c.p. excepto soja y girasol',
  },
  {
    code: 11310,
    label: 'Cultivo de papa, batata y mandioca',
  },
  {
    code: 11321,
    label: 'Cultivo de tomate',
  },
  {
    code: 11329,
    label: 'Cultivo de bulbos, brotes, raíces y hortalizas de fruto n.c.p.',
  },
  {
    code: 11331,
    label: 'Cultivo de hortalizas de hoja y de otras hortalizas frescas',
  },
  {
    code: 11341,
    label: 'Cultivo de legumbres frescas',
  },
  {
    code: 11342,
    label: 'Cultivo de legumbres secas',
  },
  {
    code: 11400,
    label: 'Cultivo de tabaco',
  },
  {
    code: 11501,
    label: 'Cultivo de algodón',
  },
  {
    code: 11509,
    label: 'Cultivo de plantas para la obtención de fibras n.c.p.',
  },
  {
    code: 11911,
    label: 'Cultivo de flores',
  },
  {
    code: 11912,
    label: 'Cultivo de plantas ornamentales',
  },
  {
    code: 11990,
    label: 'Cultivos temporales n.c.p.',
  },
  {
    code: 12110,
    label: 'Cultivo de vid para vinificar',
  },
  {
    code: 12121,
    label: 'Cultivo de uva de mesa',
  },
  {
    code: 12200,
    label: 'Cultivo de frutas cítricas',
  },
  {
    code: 12311,
    label: 'Cultivo de manzana y pera',
  },
  {
    code: 12319,
    label: 'Cultivo de frutas de pepita n.c.p.',
  },
  {
    code: 12320,
    label: 'Cultivo de frutas de carozo',
  },
  {
    code: 12410,
    label: 'Cultivo de frutas tropicales y subtropicales',
  },
  {
    code: 12420,
    label: 'Cultivo de frutas secas',
  },
  {
    code: 12490,
    label: 'Cultivo de frutas n.c.p.',
  },
  {
    code: 12510,
    label: 'Cultivo de caña de azúcar',
  },
  {
    code: 12590,
    label: 'Cultivo de plantas sacaríferas n.c.p.',
  },
  {
    code: 12600,
    label: 'Cultivo de frutos oleaginosos',
  },
  {
    code: 12701,
    label: 'Cultivo de yerba mate',
  },
  {
    code: 12709,
    label:
      'Cultivo de té y otras plantas cuyas hojas se utilizan para preparar infusiones',
  },
  {
    code: 12800,
    label: 'Cultivo de especias y de plantas aromáticas y medicinales',
  },
  {
    code: 12900,
    label: 'Cultivos perennes n.c.p.',
  },
  {
    code: 13011,
    label: 'Producción de semillas híbridas de cereales y oleaginosas',
  },
  {
    code: 13012,
    label:
      'Producción de semillas varietales o autofecundadas de cereales, oleaginosas, y forrajeras',
  },
  {
    code: 13013,
    label:
      'Producción de semillas de hortalizas y legumbres, flores y plantas ornamentales y árboles frutales',
  },
  {
    code: 13019,
    label: 'Producción de semillas de cultivos agrícolas n.c.p.',
  },
  {
    code: 13020,
    label: 'Producción de otras formas de propagación de cultivos agrícolas',
  },
  {
    code: 14113,
    label:
      'Cría de ganado bovino, excepto la realizada en cabañas y para la producción de leche',
  },
  {
    code: 14114,
    label:
      'Invernada  de ganado bovino excepto el engorde en corrales (Feed-Lot)',
  },
  {
    code: 14115,
    label: 'Engorde en corrales (Feed-Lot)',
  },
  {
    code: 14121,
    label: 'Cría de ganado bovino realizada en cabañas',
  },
  {
    code: 14211,
    label: 'Cría de ganado equino, excepto la realizada en haras',
  },
  {
    code: 14300,
    label: 'Cría de camélidos',
  },
  {
    code: 14410,
    label:
      'Cría de ganado ovino -excepto en cabañas y para la  producción de lana y leche',
  },
  {
    code: 14420,
    label: 'Cría de ganado ovino realizada en cabañas',
  },
  {
    code: 14430,
    label:
      'Cría de ganado caprino -excepto la realizada en cabañas y para producción de pelos y de leche',
  },
  {
    code: 14440,
    label: 'Cría de ganado caprino realizada en cabañas',
  },
  {
    code: 14510,
    label: 'Cría de ganado porcino, excepto la realizada en cabañas',
  },
  {
    code: 14520,
    label: 'Cría de ganado porcino realizado en cabañas',
  },
  {
    code: 14610,
    label: 'Producción de leche bovina',
  },
  {
    code: 14620,
    label: 'Producción de leche de oveja y de cabra',
  },
  {
    code: 14710,
    label: 'Producción de lana y pelo de oveja y cabra (cruda)',
  },
  {
    code: 14720,
    label: 'Producción de pelos de ganado n.c.p.',
  },
  {
    code: 14810,
    label: 'Cría de aves de corral, excepto para la producción de huevos',
  },
  {
    code: 14820,
    label: 'Producción de huevos',
  },
  {
    code: 14910,
    label: 'Apicultura',
  },
  {
    code: 14920,
    label: 'Cunicultura',
  },
  {
    code: 14930,
    label:
      'Cría de animales pelíferos, pilíferos y plumíferos, excepto de las especies ganaderas',
  },
  {
    code: 14990,
    label: 'Cría de animales y obtención de productos de origen animal, n.c.p.',
  },
  {
    code: 16111,
    label:
      'Servicios de labranza, siembra, transplante  y  cuidados culturales',
  },
  {
    code: 16112,
    label: 'Servicios de pulverización, desinfección y fumigación terrestre',
  },
  {
    code: 16113,
    label: 'Servicios de pulverización, desinfección y fumigación aérea',
  },
  {
    code: 16119,
    label:
      'Servicios de maquinaria agrícola n.c.p., excepto los de cosecha mecánica',
  },
  {
    code: 16120,
    label: 'Servicios de cosecha mecánica',
  },
  {
    code: 16130,
    label: 'Servicios de contratistas de mano de obra agrícola',
  },
  {
    code: 16140,
    label: 'Servicios de post cosecha',
  },
  {
    code: 16150,
    label: 'Servicios de procesamiento de semillas para su siembra',
  },
  {
    code: 16190,
    label: 'Servicios de apoyo agrícolas n.c.p',
  },
  {
    code: 16210,
    label:
      'Inseminación artificial y servicios n.c.p. para mejorar la reproducción de los animales y el rendimiento de sus productos',
  },
  {
    code: 16220,
    label: 'Servicios de contratistas de mano de obra pecuaria',
  },
  {
    code: 16230,
    label: 'Servicios de esquila de animales',
  },
  {
    code: 16291,
    label: 'Servicios para el control de plagas, baños parasiticidas, etc.',
  },
  {
    code: 16292,
    label: 'Albergue y cuidado de  animales de terceros',
  },
  {
    code: 16299,
    label: 'Servicios de apoyo pecuarios n.c.p.',
  },
  {
    code: 17010,
    label: 'Caza y repoblación  de animales de caza',
  },
  {
    code: 17020,
    label: 'Servicios de apoyo para la caza',
  },
  {
    code: 21010,
    label: 'Plantación de bosques',
  },
  {
    code: 21020,
    label: 'Repoblación y conservación de bosques nativos y zonas forestadas',
  },
  {
    code: 21030,
    label: 'Explotación de viveros forestales',
  },
  {
    code: 22010,
    label: 'Extracción de productos forestales de bosques cultivados',
  },
  {
    code: 22020,
    label: 'Extracción de productos forestales de bosques nativos',
  },
  {
    code: 24010,
    label: 'Servicios forestales para la extracción de madera',
  },
  {
    code: 24020,
    label:
      'Servicios forestales excepto los servicios para la extracción de madera',
  },
  {
    code: 31110,
    label:
      'Pesca de organismos marinos, excepto cuando es realizada en buques procesadores',
  },
  {
    code: 31120,
    label:
      'Pesca y elaboración de productos marinos realizada a bordo de buques procesadores',
  },
  {
    code: 31130,
    label:
      'Recolección de organismos marinos excepto peces, crustáceos y moluscos',
  },
  {
    code: 31200,
    label: 'Pesca continental: fluvial y lacustre',
  },
  {
    code: 31300,
    label: 'Servicios de apoyo para la pesca',
  },
  {
    code: 32000,
    label:
      'Explotación de criaderos de peces, granjas piscícolas y otros frutos acuáticos  (acuicultura)',
  },
  {
    code: 51000,
    label: 'Extracción y aglomeración de carbón',
  },
  {
    code: 52000,
    label: 'Extracción y aglomeración de lignito',
  },
  {
    code: 61000,
    label: 'Extracción de petróleo crudo',
  },
  {
    code: 62000,
    label: 'Extracción de gas natural',
  },
  {
    code: 71000,
    label: 'Extracción de minerales de hierro',
  },
  {
    code: 72100,
    label: 'Extracción de minerales y concentrados de uranio y torio',
  },
  {
    code: 72910,
    label: 'Extracción de metales preciosos',
  },
  {
    code: 72990,
    label:
      'Extracción de minerales metalíferos no ferrosos n.c.p., excepto minerales de uranio y torio',
  },
  {
    code: 81100,
    label: 'Extracción de rocas ornamentales',
  },
  {
    code: 81200,
    label: 'Extracción de piedra caliza y yeso',
  },
  {
    code: 81300,
    label: 'Extracción de arenas, canto rodado y triturados pétreos',
  },
  {
    code: 81400,
    label: 'Extracción de arcilla y caolín',
  },
  {
    code: 89110,
    label:
      'Extracción de minerales para la fabricación de abonos excepto turba',
  },
  {
    code: 89120,
    label: 'Extracción de minerales para la fabricación de productos químicos',
  },
  {
    code: 89200,
    label: 'Extracción y aglomeración de turba',
  },
  {
    code: 89300,
    label: 'Extracción de sal',
  },
  {
    code: 89900,
    label: 'Explotación de minas y canteras n.c.p.',
  },
  {
    code: 91000,
    label: 'Servicios de apoyo para la extracción de petróleo y gas natural',
  },
  {
    code: 99000,
    label:
      'Servicios de apoyo para la minería, excepto para la extracción de petróleo y gas natual',
  },
  {
    code: 101011,
    label: 'Matanza de ganado bovino',
  },
  {
    code: 101012,
    label: 'Procesamiento de carne de ganado bovino',
  },
  {
    code: 101013,
    label: 'Saladero y peladero de cueros de ganado bovino',
  },
  {
    code: 101020,
    label: 'Producción y procesamiento de carne de aves',
  },
  {
    code: 101030,
    label: 'Elaboración de fiambres y embutidos',
  },
  {
    code: 101040,
    label: 'Matanza de ganado excepto el bovino y procesamiento de su carne',
  },
  {
    code: 101091,
    label: 'Fabricación de aceites y grasas de origen animal',
  },
  {
    code: 101099,
    label:
      'Matanza de animales n.c.p. y procesamiento de su carne, elaboración de subproductos cárnicos n.c.p.',
  },
  {
    code: 102001,
    label: 'Elaboración de pescados de mar, crustáceos y  productos marinos',
  },
  {
    code: 102002,
    label:
      'Elaboración de pescados de ríos y lagunas y otros productos fluviales y lacustres',
  },
  {
    code: 102003,
    label:
      'Fabricación de aceites, grasas, harinas y productos a base de pescados',
  },
  {
    code: 103011,
    label: 'Preparación de conservas de frutas, hortalizas y legumbres',
  },
  {
    code: 103012,
    label: 'Elaboración y envasado de dulces, mermeladas y jaleas',
  },
  {
    code: 103020,
    label:
      'Elaboración de jugos naturales y sus concentrados, de frutas, hortalizas y legumbres',
  },
  {
    code: 103030,
    label: 'Elaboración de frutas, hortalizas y legumbres congeladas',
  },
  {
    code: 103091,
    label:
      'Elaboración de hortalizas y legumbres deshidratadas o desecadas, preparación n.c.p. de hortalizas y legumbres',
  },
  {
    code: 103099,
    label:
      'Elaboración de frutas deshidratadas o desecadas, preparación n.c.p. de frutas',
  },
  {
    code: 104011,
    label: 'Elaboración de aceites y grasas vegetales  sin refinar',
  },
  {
    code: 104012,
    label: 'Elaboración de aceite de oliva',
  },
  {
    code: 104013,
    label: 'Elaboración de aceites y grasas vegetales refinados',
  },
  {
    code: 104020,
    label: 'Elaboración de margarinas y grasas vegetales comestibles similares',
  },
  {
    code: 105010,
    label: 'Elaboración de leches y productos lácteos deshidratados',
  },
  {
    code: 105020,
    label: 'Elaboración de quesos',
  },
  {
    code: 105030,
    label: 'Elaboración industrial de helados',
  },
  {
    code: 105090,
    label: 'Elaboración de productos lácteos n.c.p.',
  },
  {
    code: 106110,
    label: 'Molienda de trigo',
  },
  {
    code: 106120,
    label: 'Preparación de arroz',
  },
  {
    code: 106131,
    label: 'Elaboración de alimentos a base de cereales',
  },
  {
    code: 106139,
    label:
      'Preparación y molienda de legumbres y cereales n.c.p., excepto trigo y arroz y molienda húmeda de maíz',
  },
  {
    code: 106200,
    label:
      'Elaboración de almidones y productos derivados del almidón, molienda húmeda de maíz',
  },
  {
    code: 107110,
    label: 'Elaboración de galletitas y bizcochos',
  },
  {
    code: 107121,
    label:
      'Elaboración industrial de productos de panadería, excepto galletitas y bizcochos',
  },
  {
    code: 107129,
    label: 'Elaboración de productos de panadería n.c.p.',
  },
  {
    code: 107200,
    label: 'Elaboración de azúcar',
  },
  {
    code: 107301,
    label: 'Elaboración de cacao y chocolate',
  },
  {
    code: 107309,
    label: 'Elaboración de productos de confitería n.c.p.',
  },
  {
    code: 107410,
    label: 'Elaboración de pastas alimentarias frescas',
  },
  {
    code: 107420,
    label: 'Elaboración de pastas alimentarias secas',
  },
  {
    code: 107500,
    label: 'Elaboración de comidas preparadas para reventa',
  },
  {
    code: 107911,
    label: 'Tostado, torrado y molienda de café',
  },
  {
    code: 107912,
    label: 'Elaboración y molienda de hierbas aromáticas y  especias',
  },
  {
    code: 107920,
    label: 'Preparación de hojas de té',
  },
  {
    code: 107930,
    label: 'Elaboración de yerba mate',
  },
  {
    code: 107991,
    label: 'Elaboración de extractos, jarabes y concentrados',
  },
  {
    code: 107992,
    label: 'Elaboración de vinagres',
  },
  {
    code: 107999,
    label: 'Elaboración de productos alimenticios n.c.p.',
  },
  {
    code: 108000,
    label: 'Elaboración de alimentos preparados para animales',
  },
  {
    code: 109000,
    label: 'Servicios industriales para la elaboración de alimentos y bebidas',
  },
  {
    code: 110100,
    label: 'Destilación, rectificación y mezcla de bebidas espiritosas',
  },
  {
    code: 110211,
    label: 'Elaboración de mosto',
  },
  {
    code: 110212,
    label: 'Elaboración de vinos',
  },
  {
    code: 110290,
    label: 'Elaboración de sidra y otras bebidas alcohólicas fermentadas',
  },
  {
    code: 110300,
    label: 'Elaboración de cerveza, bebidas malteadas y malta',
  },
  {
    code: 110411,
    label: 'Embotellado de aguas naturales y minerales',
  },
  {
    code: 110412,
    label: 'Fabricación de sodas',
  },
  {
    code: 110420,
    label: 'Elaboración de bebidas gaseosas, excepto soda',
  },
  {
    code: 110491,
    label: 'Elaboración de hielo',
  },
  {
    code: 110492,
    label: 'Elaboración de bebidas no alcohólicas n.c.p.',
  },
  {
    code: 120010,
    label: 'Preparación de hojas de tabaco',
  },
  {
    code: 120091,
    label: 'Elaboración de cigarrillos',
  },
  {
    code: 120099,
    label: 'Elaboración de productos de tabaco n.c.p.',
  },
  {
    code: 131110,
    label: 'Preparación de fibras textiles vegetales, desmotado de algodón',
  },
  {
    code: 131120,
    label: 'Preparación de fibras animales de uso textil',
  },
  {
    code: 131131,
    label: 'Fabricación de hilados textiles de lana, pelos y sus mezclas',
  },
  {
    code: 131132,
    label: 'Fabricación de hilados textiles de algodón y sus mezclas',
  },
  {
    code: 131139,
    label:
      'Fabricación de hilados textiles n.c.p., excepto de lana  y de algodón',
  },
  {
    code: 131201,
    label:
      'Fabricación de tejidos (telas) planos de lana y sus mezclas, incluye hilanderías y tejedurías integradas',
  },
  {
    code: 131202,
    label:
      'Fabricación de tejidos (telas) planos de algodón y sus mezclas, incluye hilanderías y tejedurías integradas',
  },
  {
    code: 131209,
    label:
      'Fabricación de tejidos (telas) planos de fibras textiles n.c.p., incluye hilanderías y tejedurías integradas',
  },
  {
    code: 131300,
    label: 'Acabado de productos textiles',
  },
  {
    code: 139100,
    label: 'Fabricación de tejidos de punto',
  },
  {
    code: 139201,
    label:
      'Fabricación de frazadas, mantas, ponchos, colchas, cobertores, etc.',
  },
  {
    code: 139202,
    label: 'Fabricación de ropa de cama y mantelería',
  },
  {
    code: 139203,
    label: 'Fabricación de artículos de lona y sucedáneos de lona',
  },
  {
    code: 139204,
    label:
      'Fabricación de bolsas de materiales textiles para productos a granel',
  },
  {
    code: 139209,
    label:
      'Fabricación de artículos confeccionados de materiales textiles n.c.p., excepto prendas de vestir',
  },
  {
    code: 139300,
    label: 'Fabricación de tapices y alfombras',
  },
  {
    code: 139400,
    label: 'Fabricación de cuerdas, cordeles, bramantes y redes',
  },
  {
    code: 139900,
    label: 'Fabricación de productos textiles n.c.p.',
  },
  {
    code: 141110,
    label: 'Confección de ropa interior, prendas para dormir y para la playa',
  },
  {
    code: 141120,
    label: 'Confección de ropa de trabajo, uniformes y guardapolvos',
  },
  {
    code: 141130,
    label: 'Confección de prendas de vestir para bebés y niños',
  },
  {
    code: 141140,
    label: 'Confección de prendas deportivas',
  },
  {
    code: 141191,
    label: 'Fabricación de accesorios de vestir excepto de cuero',
  },
  {
    code: 141199,
    label:
      'Confección de prendas de vestir n.c.p., excepto prendas de piel, cuero y de punto',
  },
  {
    code: 141201,
    label: 'Fabricación de accesorios de vestir de cuero',
  },
  {
    code: 141202,
    label: 'Confección de prendas de vestir de cuero',
  },
  {
    code: 142000,
    label: 'Terminación y teñido de pieles, fabricación de artículos de piel',
  },
  {
    code: 143010,
    label: 'Fabricación de medias',
  },
  {
    code: 143020,
    label: 'Fabricación de prendas de vestir y artículos similares de punto',
  },
  {
    code: 149000,
    label: 'Servicios industriales para la industria confeccionista',
  },
  {
    code: 151100,
    label: 'Curtido y terminación de cueros',
  },
  {
    code: 151200,
    label:
      'Fabricación de maletas, bolsos de mano y similares, artículos de talabartería y artículos de cuero n.c.p.',
  },
  {
    code: 152011,
    label:
      'Fabricación de calzado de cuero, excepto calzado deportivo y ortopédico',
  },
  {
    code: 152021,
    label:
      'Fabricación de calzado de materiales n.c.p., excepto calzado deportivo y ortopédico',
  },
  {
    code: 152031,
    label: 'Fabricación de calzado deportivo',
  },
  {
    code: 152040,
    label: 'Fabricación de partes de calzado',
  },
  {
    code: 161001,
    label: 'Aserrado y cepillado de madera  nativa',
  },
  {
    code: 161002,
    label: 'Aserrado y cepillado de madera implantada',
  },
  {
    code: 162100,
    label:
      'Fabricación de hojas de madera para enchapado, fabricación de tableros contrachapados, tableros laminados, tableros de partículas y tableros y paneles n.c.p.',
  },
  {
    code: 162201,
    label:
      'Fabricación de aberturas y estructuras de madera para la construcción',
  },
  {
    code: 162202,
    label: 'Fabricación de viviendas prefabricadas de madera',
  },
  {
    code: 162300,
    label: 'Fabricación de recipientes de madera',
  },
  {
    code: 162901,
    label: 'Fabricación de ataúdes',
  },
  {
    code: 162902,
    label: 'Fabricación de artículos de madera en tornerías',
  },
  {
    code: 162903,
    label: 'Fabricación de productos de corcho',
  },
  {
    code: 162909,
    label:
      'Fabricación de productos de madera n.c.p, fabricación de artículos de paja y materiales trenzables',
  },
  {
    code: 170101,
    label: 'Fabricación de pasta de madera',
  },
  {
    code: 170102,
    label: 'Fabricación de papel y cartón excepto envases',
  },
  {
    code: 170201,
    label: 'Fabricación de papel ondulado y envases de papel',
  },
  {
    code: 170202,
    label: 'Fabricación de cartón ondulado y envases de cartón',
  },
  {
    code: 170910,
    label:
      'Fabricación de artículos de papel y cartón de uso doméstico e higiénico sanitario',
  },
  {
    code: 170990,
    label: 'Fabricación de artículos de papel y cartón n.c.p.',
  },
  {
    code: 181101,
    label: 'Impresión de diarios y revistas',
  },
  {
    code: 181109,
    label: 'Impresión n.c.p., excepto de diarios y revistas',
  },
  {
    code: 181200,
    label: 'Servicios relacionados con la impresión',
  },
  {
    code: 182000,
    label: 'Reproducción de grabaciones',
  },
  {
    code: 191000,
    label: 'Fabricación de productos de hornos de coque',
  },
  {
    code: 192000,
    label: 'Fabricación de productos de la refinación del petróleo',
  },
  {
    code: 201110,
    label:
      'Fabricación de gases industriales y medicinales comprimidos o licuados',
  },
  {
    code: 201120,
    label: 'Fabricación de curtientes naturales y sintéticos',
  },
  {
    code: 201130,
    label:
      'Fabricación de materias colorantes básicas, excepto pigmentos preparados',
  },
  {
    code: 201140,
    label:
      'Fabricación de combustible nuclear, sustancias y materiales radiactivos',
  },
  {
    code: 201180,
    label: 'Fabricación de materias químicas inorgánicas básicas n.c.p.',
  },
  {
    code: 201190,
    label: 'Fabricación de materias químicas orgánicas básicas n.c.p.',
  },
  {
    code: 201210,
    label: 'Fabricación de alcohol',
  },
  {
    code: 201220,
    label: 'Fabricación de biocombustibles excepto alcohol',
  },
  {
    code: 201300,
    label: 'Fabricación de abonos y compuestos de nitrógeno',
  },
  {
    code: 201401,
    label: 'Fabricación de resinas y cauchos sintéticos',
  },
  {
    code: 201409,
    label: 'Fabricación de materias plásticas en formas primarias n.c.p.',
  },
  {
    code: 202101,
    label:
      'Fabricación de insecticidas, plaguicidas y  productos químicos de uso agropecuario',
  },
  {
    code: 202200,
    label:
      'Fabricación de pinturas, barnices y productos de revestimiento similares, tintas de imprenta y masillas',
  },
  {
    code: 202311,
    label: 'Fabricación de preparados para limpieza, pulido y saneamiento',
  },
  {
    code: 202312,
    label: 'Fabricación de jabones y detergentes',
  },
  {
    code: 202320,
    label:
      'Fabricación de cosméticos, perfumes y  productos de higiene y tocador',
  },
  {
    code: 202906,
    label: 'Fabricación de explosivos y productos de pirotecnia',
  },
  {
    code: 202907,
    label:
      'Fabricación de colas, adhesivos, aprestos y cementos excepto los odontológicos obtenidos de sustancias minerales y vegetales',
  },
  {
    code: 202908,
    label: 'Fabricación de productos químicos n.c.p.',
  },
  {
    code: 203000,
    label: 'Fabricación de fibras manufacturadas',
  },
  {
    code: 204000,
    label:
      'Servicios industriales para la fabricación de sustancias y productos químicos',
  },
  {
    code: 210010,
    label:
      'Fabricación de medicamentos de uso humano y productos farmacéuticos',
  },
  {
    code: 210020,
    label: 'Fabricación de medicamentos de uso veterinario',
  },
  {
    code: 210030,
    label:
      'Fabricación de sustancias químicas para la elaboración de medicamentos',
  },
  {
    code: 210090,
    label:
      'Fabricación de productos de laboratorio y productos botánicos de uso farmaceútico n.c.p.',
  },
  {
    code: 221110,
    label: 'Fabricación de cubiertas y cámaras',
  },
  {
    code: 221120,
    label: 'Recauchutado y renovación de cubiertas',
  },
  {
    code: 221901,
    label: 'Fabricación de  autopartes de caucho excepto cámaras y cubiertas',
  },
  {
    code: 221909,
    label: 'Fabricación  de productos de caucho n.c.p.',
  },
  {
    code: 222010,
    label: 'Fabricación de envases plásticos',
  },
  {
    code: 222090,
    label:
      'Fabricación de productos plásticos en formas básicas y artículos de plástico n.c.p., excepto muebles',
  },
  {
    code: 231010,
    label: 'Fabricación de envases de vidrio',
  },
  {
    code: 231020,
    label: 'Fabricación y elaboración de vidrio plano',
  },
  {
    code: 231090,
    label: 'Fabricación de productos de vidrio n.c.p.',
  },
  {
    code: 239100,
    label: 'Fabricación de productos de cerámica refractaria',
  },
  {
    code: 239201,
    label: 'Fabricación de ladrillos',
  },
  {
    code: 239202,
    label: 'Fabricación de revestimientos cerámicos',
  },
  {
    code: 239209,
    label:
      'Fabricación de productos de arcilla y cerámica no refractaria para uso estructural n.c.p.',
  },
  {
    code: 239310,
    label: 'Fabricación de artículos sanitarios de cerámica',
  },
  {
    code: 239391,
    label:
      'Fabricación de objetos cerámicos para uso doméstico excepto artefactos sanitarios',
  },
  {
    code: 239399,
    label:
      'Fabricación de artículos de cerámica no refractaria para uso no estructural n.c.p.',
  },
  {
    code: 239410,
    label: 'Elaboración de cemento',
  },
  {
    code: 239421,
    label: 'Elaboración de  yeso',
  },
  {
    code: 239422,
    label: 'Elaboración de cal',
  },
  {
    code: 239510,
    label: 'Fabricación de mosaicos',
  },
  {
    code: 239591,
    label: 'Elaboración de hormigón',
  },
  {
    code: 239592,
    label: 'Fabricación de premoldeadas para la construcción',
  },
  {
    code: 239593,
    label:
      'Fabricación de artículos de cemento, fibrocemento y yeso excepto hormigón y mosaicos',
  },
  {
    code: 239600,
    label: 'Corte, tallado y acabado de la piedra',
  },
  {
    code: 239900,
    label: 'Fabricación de productos minerales no metálicos n.c.p.',
  },
  {
    code: 241001,
    label:
      'Laminación y estirado. Producción de lingotes, planchas o barras fabricadas por operadores independientes',
  },
  {
    code: 241009,
    label:
      'Fabricación en industrias básicas de productos de hierro y acero n.c.p.',
  },
  {
    code: 242010,
    label: 'Elaboración de aluminio primario y semielaborados de aluminio',
  },
  {
    code: 242090,
    label:
      'Fabricación de productos primarios de metales preciosos y metales no ferrosos n.c.p. y sus semielaborados',
  },
  {
    code: 243100,
    label: 'Fundición de hierro y acero',
  },
  {
    code: 243200,
    label: 'Fundición de metales no ferrosos',
  },
  {
    code: 251101,
    label: 'Fabricación de carpintería metálica',
  },
  {
    code: 251102,
    label: 'Fabricación de productos metálicos para uso estructural',
  },
  {
    code: 251200,
    label: 'Fabricación de tanques, depósitos y recipientes de metal',
  },
  {
    code: 251300,
    label: 'Fabricación de generadores de vapor',
  },
  {
    code: 252000,
    label: 'Fabricación de armas y municiones',
  },
  {
    code: 259100,
    label:
      'Forjado, prensado, estampado y laminado de metales, pulvimetalurgia',
  },
  {
    code: 259200,
    label:
      'Tratamiento y revestimiento de metales y trabajos de metales en general',
  },
  {
    code: 259301,
    label: 'Fabricación de herramientas manuales y sus accesorios',
  },
  {
    code: 259302,
    label:
      'Fabricación de artículos de cuchillería y utensillos de mesa y de cocina',
  },
  {
    code: 259309,
    label:
      'Fabricación de cerraduras, herrajes y artículos de ferretería n.c.p.',
  },
  {
    code: 259910,
    label: 'Fabricación de envases metálicos',
  },
  {
    code: 259991,
    label: 'Fabricación de tejidos de alambre',
  },
  {
    code: 259992,
    label: 'Fabricación de cajas de seguridad',
  },
  {
    code: 259993,
    label: 'Fabricación de productos metálicos de tornería y/o matricería',
  },
  {
    code: 259999,
    label: 'Fabricación de productos elaborados de metal n.c.p.',
  },
  {
    code: 261000,
    label: 'Fabricación de componentes electrónicos',
  },
  {
    code: 262000,
    label: 'Fabricación de equipos y productos informáticos',
  },
  {
    code: 263000,
    label:
      'Fabricación  de equipos de comunicaciones y transmisores de radio y televisión',
  },
  {
    code: 264000,
    label:
      'Fabricación de receptores de radio y televisión, aparatos de grabación y reproducción de sonido y video, y productos conexos',
  },
  {
    code: 265101,
    label:
      'Fabricación de instrumentos y aparatos para medir, verificar, ensayar, navegar y otros fines, excepto el equipo de control de procesos industriales',
  },
  {
    code: 265102,
    label: 'Fabricación de equipo de control de procesos industriales',
  },
  {
    code: 265200,
    label: 'Fabricación de relojes',
  },
  {
    code: 266010,
    label:
      'Fabricación de equipo médico y quirúrgico y de aparatos ortopédicos principalmente electrónicos y/o eléctricos',
  },
  {
    code: 266090,
    label:
      'Fabricación de equipo médico y quirúrgico y de aparatos ortopédicos n.c.p.',
  },
  {
    code: 267001,
    label:
      'Fabricación de equipamiento e instrumentos ópticos y sus accesorios',
  },
  {
    code: 267002,
    label:
      'Fabricación de aparatos y accesorios para fotografía excepto películas, placas y papeles sensibles',
  },
  {
    code: 268000,
    label: 'Fabricación de soportes ópticos y magnéticos',
  },
  {
    code: 271010,
    label: 'Fabricación de motores, generadores y transformadores eléctricos',
  },
  {
    code: 271020,
    label:
      'Fabricación de aparatos de distribución y control de la energía eléctrica',
  },
  {
    code: 272000,
    label: 'Fabricación de acumuladores, pilas y baterías primarias',
  },
  {
    code: 273110,
    label: 'Fabricación de cables de fibra óptica',
  },
  {
    code: 273190,
    label: 'Fabricación de hilos y cables aislados n.c.p.',
  },
  {
    code: 274000,
    label: 'Fabricación de lámparas eléctricas y equipo de iluminación',
  },
  {
    code: 275010,
    label:
      'Fabricación de cocinas, calefones, estufas y calefactores no eléctricos',
  },
  {
    code: 275020,
    label: 'Fabricación de heladeras, "freezers", lavarropas y secarropas',
  },
  {
    code: 275091,
    label:
      'Fabricación de ventiladores, extractores de aire, aspiradoras y similares',
  },
  {
    code: 275092,
    label:
      'Fabricación de planchas, calefactores, hornos eléctricos, tostadoras y otros aparatos generadores de calor',
  },
  {
    code: 275099,
    label: 'Fabricación de aparatos de uso doméstico n.c.p.',
  },
  {
    code: 279000,
    label: 'Fabricación  de equipo eléctrico n.c.p.',
  },
  {
    code: 281100,
    label:
      'Fabricación  de  motores  y  turbinas,  excepto  motores  para aeronaves, vehículos automotores   y motocicletas',
  },
  {
    code: 281201,
    label: 'Fabricación de bombas',
  },
  {
    code: 281301,
    label: 'Fabricación de compresores, grifos y válvulas',
  },
  {
    code: 281400,
    label:
      'Fabricación de cojinetes, engranajes, trenes de engranaje y piezas de transmisión',
  },
  {
    code: 281500,
    label: 'Fabricación de hornos, hogares y quemadores',
  },
  {
    code: 281600,
    label: 'Fabricación de maquinaria y equipo de elevación y manipulación',
  },
  {
    code: 281700,
    label:
      'Fabricación de maquinaria y equipo de oficina, excepto equipo informático',
  },
  {
    code: 281900,
    label: 'Fabricación de  maquinaria y equipo de uso general n.c.p.',
  },
  {
    code: 282110,
    label: 'Fabricación de tractores',
  },
  {
    code: 282120,
    label: 'Fabricación de maquinaria y equipo de uso agropecuario y forestal',
  },
  {
    code: 282130,
    label: 'Fabricación de implementos de uso agropecuario',
  },
  {
    code: 282200,
    label: 'Fabricación de máquinas herramienta',
  },
  {
    code: 282300,
    label: 'Fabricación de maquinaria metalúrgica',
  },
  {
    code: 282400,
    label:
      'Fabricación de maquinaria para la explotación de minas y canteras y para obras de construcción',
  },
  {
    code: 282500,
    label:
      'Fabricación de maquinaria para la elaboración de alimentos, bebidas y tabaco',
  },
  {
    code: 282600,
    label:
      'Fabricación de maquinaria para la elaboración de productos textiles, prendas de vestir y cueros',
  },
  {
    code: 282901,
    label:
      'Fabricación de maquinaria para la industria del papel y las artes gráficas',
  },
  {
    code: 282909,
    label: 'Fabricación de maquinaria y equipo de uso especial n.c.p.',
  },
  {
    code: 291000,
    label: 'Fabricación de vehículos automotores',
  },
  {
    code: 292000,
    label:
      'Fabricación de carrocerías para vehículos automotores, fabricación de remolques y semirremolques',
  },
  {
    code: 293011,
    label: 'Rectificación de motores',
  },
  {
    code: 293090,
    label:
      'Fabricación de partes, piezas y accesorios para vehículos automotores y sus motores n.c.p.',
  },
  {
    code: 301100,
    label: 'Construcción y reparación de buques',
  },
  {
    code: 301200,
    label: 'Construcción y reparación de embarcaciones de recreo y deporte',
  },
  {
    code: 302000,
    label:
      'Fabricación y reparación de locomotoras y de material rodante para transporte ferroviario',
  },
  {
    code: 303000,
    label: 'Fabricación y reparación de aeronaves',
  },
  {
    code: 309100,
    label: 'Fabricación de motocicletas',
  },
  {
    code: 309200,
    label: 'Fabricación de bicicletas y de sillones de ruedas ortopédicos',
  },
  {
    code: 309900,
    label: 'Fabricación de equipo de transporte n.c.p.',
  },
  {
    code: 310010,
    label:
      'Fabricación de muebles y partes de muebles, principalmente de madera',
  },
  {
    code: 310020,
    label:
      'Fabricación de muebles y partes de muebles, excepto los que son principalmente de madera (metal, plástico, etc.)',
  },
  {
    code: 310030,
    label: 'Fabricación de somieres y colchones',
  },
  {
    code: 321011,
    label: 'Fabricación de joyas finas y artículos conexos',
  },
  {
    code: 321012,
    label: 'Fabricación de objetos de platería',
  },
  {
    code: 321020,
    label: 'Fabricación de bijouterie',
  },
  {
    code: 322001,
    label: 'Fabricación de instrumentos de música',
  },
  {
    code: 323001,
    label: 'Fabricación de artículos de deporte',
  },
  {
    code: 324000,
    label: 'Fabricación de juegos y juguetes',
  },
  {
    code: 329010,
    label:
      'Fabricación de lápices, lapiceras,  bolígrafos, sellos y artículos similares para oficinas y artistas',
  },
  {
    code: 329020,
    label: 'Fabricación de escobas, cepillos y pinceles',
  },
  {
    code: 329030,
    label: 'Fabricación de carteles, señales e indicadores  -eléctricos o no-',
  },
  {
    code: 329040,
    label: 'Fabricación de equipo de protección y seguridad, excepto calzado',
  },
  {
    code: 329090,
    label: 'Industrias manufactureras n.c.p.',
  },
  {
    code: 331101,
    label:
      'Reparación y mantenimiento de productos de metal, excepto maquinaria y equipo',
  },
  {
    code: 331210,
    label: 'Reparación y mantenimiento de maquinaria de uso general',
  },
  {
    code: 331220,
    label:
      'Reparación y mantenimiento de maquinaria y equipo de uso agropecuario y forestal',
  },
  {
    code: 331290,
    label: 'Reparación y mantenimiento de maquinaria de uso especial n.c.p.',
  },
  {
    code: 331400,
    label: 'Reparación y mantenimiento de maquinaria y aparatos eléctricos',
  },
  {
    code: 331900,
    label: 'Reparación y mantenimiento de máquinas y equipo n.c.p.',
  },
  {
    code: 332000,
    label: 'Instalación de maquinaria y equipos industriales',
  },
  {
    code: 351110,
    label: 'Generación de energía térmica convencional',
  },
  {
    code: 351120,
    label: 'Generación de energía térmica nuclear',
  },
  {
    code: 351130,
    label: 'Generación de energía hidráulica',
  },
  {
    code: 351190,
    label: 'Generación de energía n.c.p.',
  },
  {
    code: 351201,
    label: 'Transporte de energía eléctrica',
  },
  {
    code: 351310,
    label: 'Comercio mayorista de energía eléctrica',
  },
  {
    code: 351320,
    label: 'Distribución de energía eléctrica',
  },
  {
    code: 352010,
    label: 'Fabricación de gas y procesamiento de gas natural',
  },
  {
    code: 352020,
    label: 'Distribución de combustibles gaseosos por tuberías',
  },
  {
    code: 353001,
    label: 'Suministro de vapor y aire acondicionado',
  },
  {
    code: 360010,
    label:
      'Captación, depuración y distribución de agua de fuentes subterráneas',
  },
  {
    code: 360020,
    label:
      'Captación, depuración y distribución de agua de fuentes superficiales',
  },
  {
    code: 370000,
    label:
      'Servicios de depuración de aguas residuales, alcantarillado y cloacas',
  },
  {
    code: 381100,
    label:
      'Recolección, transporte, tratamiento y disposición final de residuos no peligrosos',
  },
  {
    code: 381200,
    label:
      'Recolección, transporte, tratamiento y disposición final de residuos peligrosos',
  },
  {
    code: 382010,
    label: 'Recuperación de materiales y desechos metálicos',
  },
  {
    code: 382020,
    label: 'Recuperación de materiales y desechos no metálicos',
  },
  {
    code: 390000,
    label: 'Descontaminación y otros servicios de gestión de residuos',
  },
  {
    code: 410011,
    label: 'Construcción, reforma y reparación de edificios residenciales',
  },
  {
    code: 410021,
    label: 'Construcción, reforma y reparación de edificios no residenciales',
  },
  {
    code: 421000,
    label:
      'Construcción, reforma y reparación de obras de infraestructura para el transporte',
  },
  {
    code: 422100,
    label: 'Perforación de pozos de agua',
  },
  {
    code: 422200,
    label:
      'Construcción, reforma y reparación de redes distribución de electricidad, gas, agua, telecomunicaciones y de otros servicios públicos',
  },
  {
    code: 429010,
    label: 'Construcción, reforma y reparación de obras hidráulicas',
  },
  {
    code: 429090,
    label: 'Construcción de obras de ingeniería civil n.c.p.',
  },
  {
    code: 431100,
    label: 'Demolición y voladura de edificios y de sus partes',
  },
  {
    code: 431210,
    label: 'Movimiento de suelos y preparación de terrenos para obras',
  },
  {
    code: 432110,
    label:
      'Instalación de sistemas de iluminación, control y señalización eléctrica para el transporte',
  },
  {
    code: 432190,
    label:
      'Instalación, ejecución y mantenimiento de instalaciones eléctricas, electromecánicas y electrónicas n.c.p.',
  },
  {
    code: 432200,
    label:
      'Instalaciones de gas, agua, sanitarios y de climatización, con sus artefactos conexos',
  },
  {
    code: 432910,
    label: 'Instalaciones de ascensores, montacargas y  escaleras mecánicas',
  },
  {
    code: 432920,
    label: 'Aislamiento térmico, acústico, hídrico y antivibratorio',
  },
  {
    code: 432990,
    label: 'Instalaciones para edificios y obras de ingeniería civil n.c.p.',
  },
  {
    code: 433010,
    label: 'Instalaciones de carpintería, herrería de obra y artística',
  },
  {
    code: 433020,
    label: 'Terminación y revestimiento de paredes y pisos',
  },
  {
    code: 433030,
    label: 'Colocación de cristales en obra',
  },
  {
    code: 433040,
    label: 'Pintura y trabajos de decoración',
  },
  {
    code: 433090,
    label: 'Terminación de edificios n.c.p.',
  },
  {
    code: 439100,
    label:
      'Alquiler de equipo de construcción o demolición dotado de operarios',
  },
  {
    code: 439910,
    label:
      'Hincado de pilotes, cimentación y otros trabajos de hormigón armado',
  },
  {
    code: 439990,
    label: 'Actividades especializadas de construcción n.c.p.',
  },
  {
    code: 451110,
    label: 'Venta de autos, camionetas y utilitarios nuevos',
  },
  {
    code: 451190,
    label: 'Venta de vehículos automotores nuevos n.c.p.',
  },
  {
    code: 451210,
    label: 'Venta de autos, camionetas y utilitarios, usados',
  },
  {
    code: 451290,
    label: 'Venta de vehículos automotores usados n.c.p.',
  },
  {
    code: 452101,
    label: 'Lavado automático y manual de vehículos automotores',
  },
  {
    code: 452210,
    label: 'Reparación de cámaras y cubiertas',
  },
  {
    code: 452220,
    label:
      'Reparación de amortiguadores,  alineación de dirección y balanceo de ruedas',
  },
  {
    code: 452300,
    label:
      'Instalación y reparación de parabrisas, lunetas y ventanillas, cerraduras no eléctricas y grabado de cristales',
  },
  {
    code: 452401,
    label:
      'Reparaciones eléctricas del tablero e instrumental, reparación y recarga de baterías, instalación de alarmas, radios, sistemas de climatización',
  },
  {
    code: 452500,
    label: 'Tapizado y retapizado de automotores',
  },
  {
    code: 452600,
    label:
      'Reparación y pintura de carrocerías, colocación y reparación de guardabarros y protecciones exteriores',
  },
  {
    code: 452700,
    label: 'Instalación y reparación de caños de escape y radiadores',
  },
  {
    code: 452800,
    label: 'Mantenimiento y reparación de frenos y embragues',
  },
  {
    code: 452910,
    label: 'Instalación y reparación de equipos de GNC',
  },
  {
    code: 452990,
    label: 'Mantenimiento y reparación del motor n.c.p., mecánica integral',
  },
  {
    code: 453100,
    label:
      'Venta al por mayor de partes, piezas y accesorios de vehículos automotores',
  },
  {
    code: 453210,
    label: 'Venta al por menor de cámaras y cubiertas',
  },
  {
    code: 453220,
    label: 'Venta al por menor de baterías',
  },
  {
    code: 453291,
    label: 'Venta al por menor de partes, piezas y accesorios nuevos n.c.p.',
  },
  {
    code: 453292,
    label: 'Venta al por menor de partes, piezas y accesorios usados n.c.p.',
  },
  {
    code: 454010,
    label: 'Venta de motocicletas y de sus partes, piezas y accesorios',
  },
  {
    code: 454020,
    label: 'Mantenimiento y reparación de motocicletas',
  },
  {
    code: 461011,
    label:
      'Venta al por mayor en comisión o consignación de cereales (incluye arroz), oleaginosas y forrajeras excepto semillas',
  },
  {
    code: 461012,
    label: 'Venta al por mayor en comisión o consignación de semillas',
  },
  {
    code: 461013,
    label: 'Venta al por mayor en comisión o consignación de frutas',
  },
  {
    code: 461014,
    label:
      'Acopio y acondicionamiento en comisión o consignación de cereales (incluye arroz), oleaginosas y forrajeras excepto semillas',
  },
  {
    code: 461019,
    label:
      'Venta al por mayor en comisión o consignación de productos agrícolas n.c.p.',
  },
  {
    code: 461021,
    label:
      'Venta al por mayor en comisión o consignación de ganado bovino en pie',
  },
  {
    code: 461022,
    label:
      'Venta al por mayor en comisión o consignación de ganado en pie excepto bovino',
  },
  {
    code: 461029,
    label:
      'Venta al por mayor en comisión o consignación de productos pecuarios n.c.p.',
  },
  {
    code: 461031,
    label: 'Operaciones de intermediación de carne - consignatario directo -',
  },
  {
    code: 461032,
    label:
      'Operaciones de intermediación de carne excepto consignatario directo',
  },
  {
    code: 461039,
    label:
      'Venta al por mayor en comisión o consignación de alimentos, bebidas y tabaco n.c.p.',
  },
  {
    code: 461040,
    label: 'Venta al por mayor en comisión o consignación de combustibles',
  },
  {
    code: 461092,
    label:
      'Venta al por mayor en comisión o consignación de  madera y materiales para la construcción',
  },
  {
    code: 461093,
    label:
      'Venta al por mayor en comisión o consignación de minerales, metales y productos químicos industriales',
  },
  {
    code: 461094,
    label:
      'Venta al por mayor en comisión o consignación de  maquinaria, equipo profesional industrial y comercial, embarcaciones y aeronaves',
  },
  {
    code: 461095,
    label:
      'Venta al por mayor en comisión o consignación de papel, cartón, libros, revistas, diarios, materiales de embalaje y artículos de librería',
  },
  {
    code: 461099,
    label:
      'Venta al por mayor en comisión o consignación de  mercaderías n.c.p.',
  },
  {
    code: 462110,
    label: 'Acopio de algodón',
  },
  {
    code: 462120,
    label: 'Venta al por mayor de semillas y granos para forrajes',
  },
  {
    code: 462131,
    label:
      'Venta al por mayor de cereales (incluye arroz), oleaginosas y forrajeras excepto semillas',
  },
  {
    code: 462132,
    label:
      'Acopio y acondicionamiento de cereales y semillas, excepto de algodón y semillas y granos para forrajes',
  },
  {
    code: 462190,
    label:
      'Venta al por mayor de materias primas agrícolas y de la silvicultura n.c.p.',
  },
  {
    code: 462201,
    label: 'Venta al por mayor de lanas, cueros en bruto y productos afines',
  },
  {
    code: 462209,
    label:
      'Venta al por mayor de materias primas pecuarias n.c.p. incluso animales vivos',
  },
  {
    code: 463111,
    label: 'Venta al por mayor de productos lácteos',
  },
  {
    code: 463112,
    label: 'Venta al por mayor de fiambres y quesos',
  },
  {
    code: 463121,
    label: 'Venta al por mayor de carnes rojas y derivados',
  },
  {
    code: 463129,
    label:
      'Venta al por mayor de aves, huevos y productos de granja y de la caza n.c.p.',
  },
  {
    code: 463130,
    label: 'Venta al por mayor de pescado',
  },
  {
    code: 463140,
    label:
      'Venta al por mayor y empaque de frutas, de legumbres y hortalizas frescas',
  },
  {
    code: 463151,
    label:
      'Venta al por mayor de pan, productos de confitería y pastas frescas',
  },
  {
    code: 463152,
    label: 'Venta al por mayor de azúcar',
  },
  {
    code: 463153,
    label: 'Venta al por mayor de aceites y grasas',
  },
  {
    code: 463154,
    label:
      'Venta al por mayor de café, té, yerba mate y otras infusiones y especias y condimentos',
  },
  {
    code: 463159,
    label: 'Venta al por mayor de productos y subproductos de molinería n.c.p.',
  },
  {
    code: 463160,
    label:
      'Venta al por mayor de chocolates, golosinas y productos para kioscos y polirrubros n.c.p., excepto cigarrillos',
  },
  {
    code: 463170,
    label: 'Venta al por mayor de alimentos balanceados para animales',
  },
  {
    code: 463180,
    label: 'Venta al por mayor en supermercados mayoristas de alimentos',
  },
  {
    code: 463191,
    label:
      'Venta al por mayor de frutas, legumbres y cereales secos y en conserva',
  },
  {
    code: 463199,
    label: 'Venta al por mayor de productos alimenticios n.c.p.',
  },
  {
    code: 463211,
    label: 'Venta al por mayor de vino',
  },
  {
    code: 463212,
    label: 'Venta al por mayor de bebidas espiritosas',
  },
  {
    code: 463219,
    label: 'Venta al por mayor de bebidas alcohólicas n.c.p.',
  },
  {
    code: 463220,
    label: 'Venta al por mayor de bebidas no alcohólicas',
  },
  {
    code: 463300,
    label: 'Venta al por mayor de cigarrillos y productos de tabaco',
  },
  {
    code: 464111,
    label: 'Venta al por mayor de tejidos (telas)',
  },
  {
    code: 464112,
    label: 'Venta al por mayor de artículos de mercería',
  },
  {
    code: 464113,
    label:
      'Venta al por mayor de mantelería, ropa de cama y artículos textiles para el hogar',
  },
  {
    code: 464114,
    label: 'Venta al por mayor de tapices y alfombras de materiales textiles',
  },
  {
    code: 464119,
    label: 'Venta al por mayor de productos textiles n.c.p.',
  },
  {
    code: 464121,
    label: 'Venta al por mayor de prendas de vestir de cuero',
  },
  {
    code: 464122,
    label: 'Venta al por mayor de medias y prendas de punto',
  },
  {
    code: 464129,
    label:
      'Venta al por mayor de prendas y accesorios de vestir n.c.p., excepto uniformes y ropa de trabajo',
  },
  {
    code: 464130,
    label: 'Venta al por mayor de calzado excepto el ortopédico',
  },
  {
    code: 464141,
    label: 'Venta al por mayor de pieles y cueros curtidos y salados',
  },
  {
    code: 464142,
    label: 'Venta al por mayor de suelas y afines',
  },
  {
    code: 464149,
    label:
      'Venta al por mayor de artículos de marroquinería,  paraguas y productos similares n.c.p.',
  },
  {
    code: 464150,
    label: 'Venta al por mayor de uniformes y ropa de trabajo',
  },
  {
    code: 464211,
    label: 'Venta al por mayor de libros y publicaciones',
  },
  {
    code: 464212,
    label: 'Venta al por mayor de diarios y revistas',
  },
  {
    code: 464221,
    label:
      'Venta al por mayor de papel y productos de papel y cartón excepto envases',
  },
  {
    code: 464222,
    label: 'Venta al por mayor de envases de papel y cartón',
  },
  {
    code: 464223,
    label: 'Venta al por mayor de artículos de librería y papelería',
  },
  {
    code: 464310,
    label: 'Venta al por mayor de productos farmacéuticos',
  },
  {
    code: 464320,
    label:
      'Venta al por mayor de productos cosméticos, de tocador y de perfumería',
  },
  {
    code: 464330,
    label:
      'Venta al por mayor de instrumental médico y odontológico y artículos ortopédicos',
  },
  {
    code: 464340,
    label: 'Venta al por mayor de productos veterinarios',
  },
  {
    code: 464410,
    label: 'Venta al por mayor de artículos de óptica y de fotografía',
  },
  {
    code: 464420,
    label: 'Venta al por mayor de artículos de relojería, joyería y fantasías',
  },
  {
    code: 464501,
    label:
      'Venta al por mayor de electrodomésticos y artefactos para el hogar excepto equipos de audio y video',
  },
  {
    code: 464502,
    label: 'Venta al por mayor de equipos de audio, video y televisión',
  },
  {
    code: 464610,
    label:
      'Venta al por mayor de muebles excepto de oficina, artículos de mimbre y corcho, colchones y somieres',
  },
  {
    code: 464620,
    label: 'Venta al por mayor de artículos de iluminación',
  },
  {
    code: 464631,
    label: 'Venta al por mayor de artículos de vidrio',
  },
  {
    code: 464632,
    label:
      'Venta al por mayor de artículos de bazar y menaje excepto de vidrio',
  },
  {
    code: 464920,
    label: 'Venta al por mayor de materiales y productos de limpieza',
  },
  {
    code: 464930,
    label: 'Venta al por mayor de juguetes',
  },
  {
    code: 464940,
    label: 'Venta al por mayor de bicicletas y rodados similares',
  },
  {
    code: 464950,
    label: 'Venta al por mayor de artículos de esparcimiento y deportes',
  },
  {
    code: 464991,
    label: 'Venta al por mayor de flores y plantas naturales y artificiales',
  },
  {
    code: 464999,
    label: 'Venta al por mayor de artículos de uso doméstico o personal n.c.p',
  },
  {
    code: 465100,
    label:
      'Venta al por mayor de equipos, periféricos, accesorios y programas informáticos',
  },
  {
    code: 465210,
    label: 'Venta al por mayor de equipos de telefonía y comunicaciones',
  },
  {
    code: 465220,
    label: 'Venta al por mayor de componentes electrónicos',
  },
  {
    code: 465310,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso en los sectores agropecuario, jardinería, silvicultura, pesca y caza',
  },
  {
    code: 465320,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso en la elaboración de alimentos, bebidas y tabaco',
  },
  {
    code: 465330,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso en la fabricación de textiles, prendas y accesorios de vestir, calzado, artículos de cuero y marroquinería',
  },
  {
    code: 465340,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso en imprentas, artes gráficas y actividades conexas',
  },
  {
    code: 465350,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso médico y paramédico',
  },
  {
    code: 465360,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso en la industria del plástico y del caucho',
  },
  {
    code: 465390,
    label:
      'Venta al por mayor de máquinas, equipos e implementos de uso especial n.c.p.',
  },
  {
    code: 465400,
    label: 'Venta al por mayor de máquinas - herramienta de uso general',
  },
  {
    code: 465500,
    label:
      'Venta  al  por  mayor  de  vehículos,  equipos  y  máquinas  para  el transporte ferroviario, aéreo y de navegación',
  },
  {
    code: 465610,
    label: 'Venta al por mayor de muebles e instalaciones para oficinas',
  },
  {
    code: 465690,
    label:
      'Venta al por mayor de muebles e instalaciones para la industria, el comercio y los servicios n.c.p.',
  },
  {
    code: 465910,
    label: 'Venta al por mayor de máquinas y equipo de control y seguridad',
  },
  {
    code: 465920,
    label:
      'Venta al por mayor de maquinaria y equipo de oficina, excepto equipo informático',
  },
  {
    code: 465930,
    label:
      'Venta al por mayor de equipo profesional y científico e instrumentos de medida y de control n.c.p.',
  },
  {
    code: 465990,
    label: 'Venta al por mayor de máquinas, equipo y materiales conexos n.c.p.',
  },
  {
    code: 466110,
    label: 'Venta al por mayor de combustibles y lubricantes para automotores',
  },
  {
    code: 466121,
    label: 'Fraccionamiento y distribución de gas licuado',
  },
  {
    code: 466129,
    label:
      'Venta al por mayor de combustibles, lubricantes, leña y carbón, excepto gas licuado y combustibles y lubricantes para automotores',
  },
  {
    code: 466200,
    label: 'Venta al por mayor de metales y minerales metalíferos',
  },
  {
    code: 466310,
    label: 'Venta al por mayor de aberturas',
  },
  {
    code: 466320,
    label: 'Venta al por mayor de productos de madera excepto muebles',
  },
  {
    code: 466330,
    label:
      'Venta al por mayor de artículos de ferretería y materiales eléctricos',
  },
  {
    code: 466340,
    label: 'Venta al por mayor de pinturas y productos conexos',
  },
  {
    code: 466350,
    label: 'Venta al por mayor de cristales y espejos',
  },
  {
    code: 466360,
    label:
      'Venta al por mayor de artículos para plomería, instalación de gas y calefacción',
  },
  {
    code: 466370,
    label:
      'Venta al por mayor de papeles para pared, revestimiento para pisos de goma, plástico y textiles,  y artículos similares para la decoración',
  },
  {
    code: 466391,
    label:
      'Venta al por mayor de artículos de loza, cerámica y porcelana de uso en construcción',
  },
  {
    code: 466399,
    label: 'Venta al por mayor de artículos para la construcción n.c.p.',
  },
  {
    code: 466910,
    label:
      'Venta al por mayor de productos intermedios n.c.p., desperdicios y desechos textiles',
  },
  {
    code: 466920,
    label:
      'Venta al por mayor de productos intermedios n.c.p., desperdicios y desechos de papel y cartón',
  },
  {
    code: 466931,
    label: 'Venta al por mayor de artículos de plástico',
  },
  {
    code: 466932,
    label: 'Venta al por mayor de abonos, fertilizantes y plaguicidas',
  },
  {
    code: 466939,
    label:
      'Venta al por mayor de productos intermedios, desperdicios y desechos de vidrio, caucho, goma y químicos n.c.p.',
  },
  {
    code: 466940,
    label:
      'Venta al por mayor de productos intermedios n.c.p., desperdicios y desechos metálicos',
  },
  {
    code: 466990,
    label:
      'Venta al por mayor de productos intermedios, desperdicios y desechos n.c.p.',
  },
  {
    code: 469010,
    label: 'Venta al por mayor de insumos agropecuarios diversos',
  },
  {
    code: 469090,
    label: 'Venta al por mayor de mercancías n.c.p.',
  },
  {
    code: 471110,
    label: 'Venta al por menor en hipermercados',
  },
  {
    code: 471120,
    label: 'Venta al por menor en supermercados',
  },
  {
    code: 471130,
    label: 'Venta al por menor en minimercados',
  },
  {
    code: 471190,
    label:
      'Venta al por menor en kioscos, polirrubros y comercios no especializados n.c.p.',
  },
  {
    code: 471900,
    label:
      'Venta al por menor en comercios no especializados, sin predominio de productos alimenticios y bebidas',
  },
  {
    code: 472111,
    label: 'Venta al por menor de productos lácteos',
  },
  {
    code: 472112,
    label: 'Venta al por menor de fiambres y embutidos',
  },
  {
    code: 472120,
    label: 'Venta al por menor de productos de almacén y dietética',
  },
  {
    code: 472130,
    label:
      'Venta al por menor de carnes rojas, menudencias y chacinados frescos',
  },
  {
    code: 472140,
    label:
      'Venta al por menor de huevos, carne de aves y  productos de granja y de la caza',
  },
  {
    code: 472150,
    label: 'Venta al por menor de pescados y  productos de la pesca',
  },
  {
    code: 472160,
    label: 'Venta al por menor de frutas, legumbres y hortalizas frescas',
  },
  {
    code: 472171,
    label: 'Venta al por menor de pan y productos de panadería',
  },
  {
    code: 472172,
    label:
      'Venta al por menor de bombones, golosinas y demás productos de confitería',
  },
  {
    code: 472190,
    label:
      'Venta al por menor de productos alimenticios n.c.p., en comercios especializados',
  },
  {
    code: 472200,
    label: 'Venta al por menor de bebidas en comercios especializados',
  },
  {
    code: 472300,
    label: 'Venta al por menor de tabaco en comercios especializados',
  },
  {
    code: 473000,
    label:
      'Venta al por menor de combustible para vehículos automotores y motocicletas',
  },
  {
    code: 474010,
    label:
      'Venta al por menor de equipos, periféricos,  accesorios y programas informáticos',
  },
  {
    code: 474020,
    label: 'Venta al por menor de aparatos de telefonía y comunicación',
  },
  {
    code: 475110,
    label: 'Venta al por menor de hilados, tejidos y artículos de mercería',
  },
  {
    code: 475120,
    label: 'Venta al por menor de confecciones para el hogar',
  },
  {
    code: 475190,
    label:
      'Venta al por menor de artículos textiles n.c.p. excepto prendas de vestir',
  },
  {
    code: 475210,
    label: 'Venta al por menor de aberturas',
  },
  {
    code: 475220,
    label:
      'Venta al por menor de maderas y artículos de madera  y corcho, excepto muebles',
  },
  {
    code: 475230,
    label:
      'Venta al por menor de artículos de ferretería y materiales eléctricos',
  },
  {
    code: 475240,
    label: 'Venta al por menor de pinturas y productos conexos',
  },
  {
    code: 475250,
    label: 'Venta al por menor de artículos para plomería e instalación de gas',
  },
  {
    code: 475260,
    label: 'Venta al por menor de cristales, espejos, mamparas y cerramientos',
  },
  {
    code: 475270,
    label:
      'Venta al por menor de papeles para pared, revestimientos para pisos y artículos similares para la decoración',
  },
  {
    code: 475290,
    label: 'Venta al por menor de materiales de construcción n.c.p.',
  },
  {
    code: 475300,
    label:
      'Venta al por menor  de electrodomésticos, artefactos para el hogar y equipos de audio y video',
  },
  {
    code: 475410,
    label:
      'Venta al por menor de muebles para el hogar, artículos de mimbre y corcho',
  },
  {
    code: 475420,
    label: 'Venta al por menor de colchones y somieres',
  },
  {
    code: 475430,
    label: 'Venta al por menor de artículos de iluminación',
  },
  {
    code: 475440,
    label: 'Venta al por menor de artículos de bazar y menaje',
  },
  {
    code: 475490,
    label: 'Venta al por menor de artículos para el hogar n.c.p.',
  },
  {
    code: 476110,
    label: 'Venta al por menor de libros',
  },
  {
    code: 476120,
    label: 'Venta al por menor de diarios y revistas',
  },
  {
    code: 476130,
    label:
      'Venta al por menor de papel, cartón, materiales de embalaje y artículos de librería',
  },
  {
    code: 476310,
    label: 'Venta al por menor de equipos  y artículos deportivos',
  },
  {
    code: 476320,
    label: 'Venta al por menor de armas, artículos para la caza y pesca',
  },
  {
    code: 476400,
    label:
      'Venta al por menor de juguetes, artículos de cotillón y juegos de mesa',
  },
  {
    code: 477110,
    label:
      'Venta al por menor de ropa interior, medias, prendas para dormir y para la playa',
  },
  {
    code: 477120,
    label: 'Venta al por menor de uniformes escolares y guardapolvos',
  },
  {
    code: 477130,
    label: 'Venta al por menor de indumentaria para bebés y niños',
  },
  {
    code: 477140,
    label: 'Venta al por menor de indumentaria deportiva',
  },
  {
    code: 477150,
    label: 'Venta al por menor de prendas de cuero',
  },
  {
    code: 477190,
    label: 'Venta al por menor de prendas y accesorios de vestir n.c.p.',
  },
  {
    code: 477210,
    label:
      'Venta al por menor de artículos de talabartería y artículos regionales',
  },
  {
    code: 477220,
    label:
      'Venta al por menor de calzado, excepto el ortopédico y el deportivo',
  },
  {
    code: 477230,
    label: 'Venta al por menor de calzado deportivo',
  },
  {
    code: 477290,
    label:
      'Venta al por menor de artículos de marroquinería, paraguas y similares n.c.p.',
  },
  {
    code: 477310,
    label: 'Venta al por menor de productos farmacéuticos y de herboristería',
  },
  {
    code: 477320,
    label:
      'Venta al por menor de productos cosméticos, de tocador y de perfumería',
  },
  {
    code: 477330,
    label:
      'Venta al por menor de instrumental médico y odontológico y artículos ortopédicos',
  },
  {
    code: 477410,
    label: 'Venta al por menor de artículos de óptica y fotografía',
  },
  {
    code: 477420,
    label: 'Venta al por menor de artículos de relojería y joyería',
  },
  {
    code: 477430,
    label: 'Venta al por menor de bijouterie y fantasía',
  },
  {
    code: 477440,
    label:
      'Venta al por menor de flores, plantas, semillas, abonos, fertilizantes y otros productos de vivero',
  },
  {
    code: 477450,
    label: 'Venta al por menor de materiales y productos de limpieza',
  },
  {
    code: 477460,
    label: 'Venta al por menor de fuel oil, gas en garrafas, carbón y leña',
  },
  {
    code: 477470,
    label:
      'Venta al por menor de productos veterinarios, animales domésticos y alimento balanceado para mascotas',
  },
  {
    code: 477480,
    label: 'Venta al por menor de obras de arte',
  },
  {
    code: 477490,
    label: 'Venta al por menor de artículos nuevos n.c.p.',
  },
  {
    code: 477810,
    label: 'Venta al por menor de muebles usados',
  },
  {
    code: 477820,
    label: 'Venta al por menor de libros, revistas y similares usados',
  },
  {
    code: 477830,
    label: 'Venta al por menor de antigüedades',
  },
  {
    code: 477840,
    label: 'Venta al por menor de oro, monedas, sellos y similares',
  },
  {
    code: 477890,
    label:
      'Venta al por menor de artículos usados n.c.p. excepto+E1155 automotores y motocicletas',
  },
  {
    code: 478010,
    label:
      'Venta al por menor de alimentos, bebidas y tabaco en puestos móviles y mercados',
  },
  {
    code: 478090,
    label:
      'Venta al por menor de productos n.c.p. en puestos móviles y mercados',
  },
  {
    code: 479101,
    label: 'Venta al por menor por internet',
  },
  {
    code: 479109,
    label:
      'Venta al por menor por correo, televisión y otros medios de comunicación n.c.p.',
  },
  {
    code: 479900,
    label: 'Venta al por menor no realizada en establecimientos  n.c.p.',
  },
  {
    code: 491110,
    label: 'Servicio de transporte ferroviario urbano y suburbano de pasajeros',
  },
  {
    code: 491120,
    label: 'Servicio de transporte ferroviario interurbano de pasajeros',
  },
  {
    code: 491200,
    label: 'Servicio de transporte ferroviario de cargas',
  },
  {
    code: 492110,
    label:
      'Servicio de transporte automotor urbano y suburbano regular de pasajeros',
  },
  {
    code: 492120,
    label:
      'Servicios de transporte automotor de pasajeros mediante taxis y remises, alquiler de autos con chofer',
  },
  {
    code: 492130,
    label: 'Servicio de transporte escolar',
  },
  {
    code: 492140,
    label:
      'Servicio de transporte automotor urbano y suburbano no regular de pasajeros de oferta libre,  excepto mediante taxis y remises, alquiler de autos con chofer y transporte escolar',
  },
  {
    code: 492150,
    label:
      'Servicio de transporte automotor interurbano regular de pasajeros, E1203excepto transporte internacional',
  },
  {
    code: 492160,
    label:
      'Servicio de transporte automotor interurbano no regular de pasajeros',
  },
  {
    code: 492170,
    label: 'Servicio de transporte automotor internacional de pasajeros',
  },
  {
    code: 492180,
    label: 'Servicio de transporte automotor turístico de pasajeros',
  },
  {
    code: 492190,
    label: 'Servicio de transporte automotor de pasajeros n.c.p.',
  },
  {
    code: 492210,
    label: 'Servicios de mudanza',
  },
  {
    code: 492221,
    label: 'Servicio de transporte automotor de cereales',
  },
  {
    code: 492229,
    label: 'Servicio de transporte automotor de mercaderías a granel n.c.p.',
  },
  {
    code: 492230,
    label: 'Servicio de transporte automotor de animales',
  },
  {
    code: 492240,
    label: 'Servicio de transporte por camión cisterna',
  },
  {
    code: 492250,
    label:
      'Servicio de transporte automotor de mercaderías y sustancias peligrosas',
  },
  {
    code: 492280,
    label: 'Servicio de transporte automotor urbano de carga n.c.p.',
  },
  {
    code: 492290,
    label: 'Servicio de transporte automotor de cargas n.c.p.',
  },
  {
    code: 493110,
    label: 'Servicio de transporte por oleoductos',
  },
  {
    code: 493120,
    label: 'Servicio de transporte por poliductos y fueloductos',
  },
  {
    code: 493200,
    label: 'Servicio de transporte por gasoductos',
  },
  {
    code: 501100,
    label: 'Servicio de transporte marítimo de pasajeros',
  },
  {
    code: 501200,
    label: 'Servicio de transporte marítimo de carga',
  },
  {
    code: 502101,
    label: 'Servicio de transporte fluvial y lacustre de pasajeros',
  },
  {
    code: 502200,
    label: 'Servicio de transporte fluvial y lacustre de carga',
  },
  {
    code: 511000,
    label: 'Servicio de transporte aéreo de pasajeros',
  },
  {
    code: 512000,
    label: 'Servicio de transporte aéreo de cargas',
  },
  {
    code: 521010,
    label: 'Servicios de manipulación de carga en el ámbito terrestre',
  },
  {
    code: 521020,
    label: 'Servicios de manipulación de carga en el ámbito portuario',
  },
  {
    code: 521030,
    label: 'Servicios de manipulación de carga en el ámbito aéreo',
  },
  {
    code: 522010,
    label: 'Servicios de almacenamiento y depósito en silos',
  },
  {
    code: 522020,
    label: 'Servicios de almacenamiento y depósito en cámaras frigoríficas',
  },
  {
    code: 522091,
    label: 'Servicios de usuarios directos de zona franca',
  },
  {
    code: 522092,
    label: 'Servicios de gestión de depósitos fiscales',
  },
  {
    code: 522099,
    label: 'Servicios de almacenamiento y depósito n.c.p.',
  },
  {
    code: 523011,
    label:
      'Servicios de gestión aduanera realizados por despachantes de aduana',
  },
  {
    code: 523019,
    label:
      'Servicios de gestión aduanera para el transporte de mercaderías n.c.p.',
  },
  {
    code: 523020,
    label: 'Servicios de agencias marítimas para el transporte de mercaderías',
  },
  {
    code: 523031,
    label:
      'Servicios de gestión de agentes de transporte aduanero excepto agencias marítimas',
  },
  {
    code: 523032,
    label:
      'Servicios de operadores logísticos seguros (OLS) en el ámbito aduanero',
  },
  {
    code: 523039,
    label: 'Servicios de operadores logísticos n.c.p.',
  },
  {
    code: 523090,
    label:
      'Servicios de gestión y logística para el transporte de mercaderías n.c.p.',
  },
  {
    code: 524110,
    label:
      'Servicios de explotación de infraestructura para el transporte terrestre, peajes y otros derechos',
  },
  {
    code: 524120,
    label: 'Servicios  de playas de estacionamiento y garajes',
  },
  {
    code: 524130,
    label: 'Servicios de estaciones terminales de ómnibus y ferroviárias',
  },
  {
    code: 524190,
    label: 'Servicios complementarios para el transporte terrestre n.c.p.',
  },
  {
    code: 524210,
    label:
      'Servicios de explotación de infraestructura para el transporte marítimo, derechos de puerto',
  },
  {
    code: 524220,
    label: 'Servicios de guarderías náuticas',
  },
  {
    code: 524230,
    label: 'Servicios para la navegación',
  },
  {
    code: 524290,
    label: 'Servicios complementarios para el transporte marítimo n.c.p.',
  },
  {
    code: 524310,
    label:
      'Servicios de explotación de infraestructura para el transporte aéreo, derechos de aeropuerto',
  },
  {
    code: 524320,
    label: 'Servicios de hangares y estacionamiento de aeronaves',
  },
  {
    code: 524330,
    label: 'Servicios para la aeronavegación',
  },
  {
    code: 524390,
    label: 'Servicios complementarios para el transporte aéreo n.c.p.',
  },
  {
    code: 530010,
    label: 'Servicio de correo postal',
  },
  {
    code: 530090,
    label: 'Servicios de mensajerías.',
  },
  {
    code: 551010,
    label: 'Servicios de alojamiento por hora',
  },
  {
    code: 551021,
    label: 'Servicios de alojamiento en pensiones',
  },
  {
    code: 551022,
    label:
      'Servicios de alojamiento en hoteles, hosterías y residenciales similares, excepto por hora, que incluyen servicio de restaurante al público',
  },
  {
    code: 551023,
    label:
      'Servicios de alojamiento en hoteles, hosterías y residenciales similares, excepto por hora, que no incluyen servicio de restaurante al público',
  },
  {
    code: 551090,
    label: 'Servicios de hospedaje temporal n.c.p.',
  },
  {
    code: 552000,
    label: 'Servicios de alojamiento en campings',
  },
  {
    code: 561011,
    label: 'Servicios de restaurantes y cantinas sin espectáculo',
  },
  {
    code: 561012,
    label: 'Servicios de restaurantes y cantinas con espectáculo',
  },
  {
    code: 561013,
    label:
      'Servicios de "fast food" y locales de venta de comidas y bebidas al paso',
  },
  {
    code: 561014,
    label: 'Servicios de expendio de bebidas en bares',
  },
  {
    code: 561019,
    label:
      'Servicios de expendio de comidas y bebidas en establecimientos con servicio de mesa y/o en mostrador n.c.p.',
  },
  {
    code: 561020,
    label: 'Servicios de preparación de comidas para llevar',
  },
  {
    code: 561030,
    label: 'Servicio de expendio de helados',
  },
  {
    code: 561040,
    label:
      'Servicios de preparación de comidas realizadas por/para vendedores ambulantes.',
  },
  {
    code: 562010,
    label: 'Servicios de preparación de comidas para empresas y eventos',
  },
  {
    code: 562091,
    label:
      'Servicios de cantinas con atención exclusiva  a los empleados o estudiantes dentro de empresas o establecimientos educativos.',
  },
  {
    code: 562099,
    label: 'Servicios de comidas n.c.p.',
  },
  {
    code: 581100,
    label: 'Edición de libros, folletos, y otras publicaciones',
  },
  {
    code: 581200,
    label: 'Edición de directorios y listas de correos',
  },
  {
    code: 581300,
    label: 'Edición de periódicos, revistas y publicaciones periódicas',
  },
  {
    code: 581900,
    label: 'Edición n.c.p.',
  },
  {
    code: 591110,
    label: 'Producción de filmes y videocintas',
  },
  {
    code: 591120,
    label: 'Postproducción de filmes y videocintas',
  },
  {
    code: 591200,
    label: 'Distribución de filmes y videocintas',
  },
  {
    code: 591300,
    label: 'Exhibición de filmes y videocintas',
  },
  {
    code: 592000,
    label: 'Servicios de grabación de sonido y edición de música',
  },
  {
    code: 601000,
    label: 'Emisión y retransmisión de radio',
  },
  {
    code: 602100,
    label: 'Emisión y retransmisión  de televisión abierta',
  },
  {
    code: 602200,
    label: 'Operadores de televisión por suscripción.',
  },
  {
    code: 602310,
    label: 'Emisión de señales de televisión por suscripción',
  },
  {
    code: 602320,
    label: 'Producción de programas de televisión',
  },
  {
    code: 602900,
    label: 'Servicios de televisión n.c.p',
  },
  {
    code: 611010,
    label: 'Servicios de locutorios',
  },
  {
    code: 611090,
    label: 'Servicios de telefonía fija, excepto locutorios',
  },
  {
    code: 612000,
    label: 'Servicios de telefonía móvil',
  },
  {
    code: 613000,
    label:
      'Servicios de telecomunicaciones vía satélite, excepto servicios de transmisión de televisión',
  },
  {
    code: 614010,
    label: 'Servicios de proveedores de acceso a internet',
  },
  {
    code: 614090,
    label: 'Servicios de telecomunicación vía internet n.c.p.',
  },
  {
    code: 619000,
    label: 'Servicios de telecomunicaciones n.c.p.',
  },
  {
    code: 620100,
    label:
      'Servicios de consultores en informática y suministros de programas de informática',
  },
  {
    code: 620200,
    label: 'Servicios de consultores en equipo de informática',
  },
  {
    code: 620300,
    label: 'Servicios de consultores en tecnología de la información',
  },
  {
    code: 620900,
    label: 'Servicios de informática n.c.p.',
  },
  {
    code: 631110,
    label: 'Procesamiento de datos',
  },
  {
    code: 631120,
    label: 'Hospedaje de datos',
  },
  {
    code: 631190,
    label: 'Actividades conexas al procesamiento y hospedaje de datos n.c.p.',
  },
  {
    code: 631200,
    label: 'Portales web',
  },
  {
    code: 639100,
    label: 'Agencias de noticias',
  },
  {
    code: 639900,
    label: 'Servicios de información n.c.p.',
  },
  {
    code: 641100,
    label: 'Servicios de la banca central',
  },
  {
    code: 641910,
    label: 'Servicios de la banca mayorista',
  },
  {
    code: 641920,
    label: 'Servicios de la banca de inversión',
  },
  {
    code: 641930,
    label: 'Servicios de la banca minorista',
  },
  {
    code: 641941,
    label:
      'Servicios de intermediación financiera realizada por las compañías financieras',
  },
  {
    code: 641942,
    label:
      'Servicios de intermediación financiera realizada por sociedades de ahorro y préstamo para la vivienda y otros inmuebles',
  },
  {
    code: 641943,
    label:
      'Servicios de intermediación financiera realizada por cajas de crédito',
  },
  {
    code: 642000,
    label: 'Servicios de sociedades de cartera',
  },
  {
    code: 643001,
    label: 'Servicios de fideicomisos',
  },
  {
    code: 643009,
    label:
      'Fondos y sociedades de inversión y entidades financieras similares n.c.p.',
  },
  {
    code: 649100,
    label: 'Arrendamiento financiero, leasing',
  },
  {
    code: 649210,
    label: 'Actividades de crédito para financiar otras actividades económicas',
  },
  {
    code: 649220,
    label: 'Servicios de entidades de tarjeta de compra y/o crédito',
  },
  {
    code: 649290,
    label: 'Servicios de crédito n.c.p.',
  },
  {
    code: 649910,
    label: 'Servicios de agentes de mercado abierto "puros"',
  },
  {
    code: 649991,
    label:
      'Servicios de socios inversores en sociedades regulares según Ley 19.550 - S.R.L., S.C.A, etc, excepto socios inversores en sociedades anónimas incluidos en 649999 -',
  },
  {
    code: 649999,
    label: 'Servicios de financiación y actividades financieras n.c.p.',
  },
  {
    code: 651110,
    label: 'Servicios de seguros de salud',
  },
  {
    code: 651120,
    label: 'Servicios de seguros de vida',
  },
  {
    code: 651130,
    label: 'Servicios de seguros personales excepto  los de salud y de vida',
  },
  {
    code: 651210,
    label: 'Servicios de aseguradoras de riesgo de trabajo (ART)',
  },
  {
    code: 651220,
    label:
      'Servicios de seguros patrimoniales excepto los de las aseguradoras de riesgo de trabajo (ART)',
  },
  {
    code: 651310,
    label: 'Obras Sociales',
  },
  {
    code: 651320,
    label:
      'Servicios de cajas de previsión social pertenecientes a asociaciones profesionales',
  },
  {
    code: 652000,
    label: 'Reaseguros',
  },
  {
    code: 653000,
    label:
      'Administración de fondos de pensiones, excepto la seguridad social obligatoria',
  },
  {
    code: 661111,
    label: 'Servicios de mercados y cajas de valores',
  },
  {
    code: 661121,
    label: 'Servicios de mercados a término',
  },
  {
    code: 661131,
    label: 'Servicios de bolsas de comercio',
  },
  {
    code: 661910,
    label: 'Servicios bursátiles de mediación o por cuenta de terceros',
  },
  {
    code: 661920,
    label: 'Servicios de casas y agencias de cambio',
  },
  {
    code: 661930,
    label: 'Servicios de sociedades calificadoras de riesgos financieros',
  },
  {
    code: 661991,
    label: 'Servicios de envio y recepción de fondos desde y hacia el exterior',
  },
  {
    code: 661992,
    label: 'Servicios de administradoras de vales y tickets',
  },
  {
    code: 661999,
    label: 'Servicios auxiliares a la intermediación financiera n.c.p.',
  },
  {
    code: 662010,
    label: 'Servicios de evaluación de riesgos y daños',
  },
  {
    code: 662020,
    label: 'Servicios de productores  y asesores de seguros',
  },
  {
    code: 662090,
    label: 'Servicios auxiliares a los servicios de seguros n.c.p.',
  },
  {
    code: 663000,
    label:
      'Servicios de gestión de fondos a cambio de una retribución o por contrata',
  },
  {
    code: 681010,
    label:
      'Servicios de alquiler y explotación de inmuebles para fiestas, convenciones y otros eventos similares',
  },
  {
    code: 681020,
    label: 'Servicios de alquiler  de consultorios médicos',
  },
  {
    code: 681098,
    label:
      'Servicios inmobiliarios realizados por cuenta propia, con bienes urbanos propios o arrendados n.c.p.',
  },
  {
    code: 681099,
    label:
      'Servicios inmobiliarios realizados por cuenta propia, con bienes rurales propios o arrendados n.c.p.',
  },
  {
    code: 682010,
    label: 'Servicios de administración de consorcios de edificios',
  },
  {
    code: 682091,
    label: 'Servicios prestados por inmobiliarias',
  },
  {
    code: 682099,
    label:
      'Servicios inmobiliarios realizados a cambio de una retribución o por contrata n.c.p.',
  },
  {
    code: 691001,
    label: 'Servicios jurídicos',
  },
  {
    code: 691002,
    label: 'Servicios  notariales',
  },
  {
    code: 692000,
    label: 'Servicios de contabilidad, auditoría y asesoría fiscal',
  },
  {
    code: 702010,
    label:
      'Servicios de gerenciamiento de empresas e instituciones de salud, servicios de auditoria y medicina legal, servicio de asesoramiento farmacéutico',
  },
  {
    code: 702091,
    label:
      'Servicios de asesoramiento, dirección y gestión empresarial realizados por integrantes de los órganos de administración y/o fiscalización en sociedades anónimas',
  },
  {
    code: 702092,
    label:
      'Servicios de asesoramiento, dirección y gestión empresarial realizados por integrantes de cuerpos de dirección en sociedades excepto las anónimas',
  },
  {
    code: 702099,
    label: 'Servicios de asesoramiento, dirección y gestión empresarial n.c.p.',
  },
  {
    code: 711001,
    label: 'Servicios relacionados con la construcción.',
  },
  {
    code: 711002,
    label: 'Servicios geológicos y de prospección',
  },
  {
    code: 711003,
    label: 'Servicios relacionados con la electrónica y las comunicaciones',
  },
  {
    code: 711009,
    label:
      'Servicios de arquitectura e ingeniería y servicios conexos de asesoramiento técnico n.c.p.',
  },
  {
    code: 712000,
    label: 'Ensayos y análisis técnicos',
  },
  {
    code: 721010,
    label:
      'Investigación  y desarrollo experimental en el campo de la ingeniería y la tecnología',
  },
  {
    code: 721020,
    label:
      'Investigación  y desarrollo experimental en el campo de las ciencias médicas',
  },
  {
    code: 721030,
    label:
      'Investigación  y desarrollo experimental en el campo de las ciencias agropecuarias',
  },
  {
    code: 721090,
    label:
      'Investigación y desarrollo experimental en el campo de las ciencias exactas y naturales n.c.p.',
  },
  {
    code: 722010,
    label:
      'Investigación  y desarrollo experimental en el campo de las ciencias sociales',
  },
  {
    code: 722020,
    label:
      'Investigación  y desarrollo experimental en el campo de las ciencias humanas',
  },
  {
    code: 731001,
    label: 'Servicios de comercialización de tiempo y espacio publicitario',
  },
  {
    code: 731009,
    label: 'Servicios de publicidad n.c.p.',
  },
  {
    code: 732000,
    label: 'Estudio de mercado, realización de encuestas de opinión pública',
  },
  {
    code: 741000,
    label: 'Servicios de diseño especializado',
  },
  {
    code: 742000,
    label: 'Servicios de fotografía',
  },
  {
    code: 749001,
    label: 'Servicios de traducción e interpretación',
  },
  {
    code: 749002,
    label: 'Servicios de representación e intermediación de artistas y modelos',
  },
  {
    code: 749003,
    label:
      'Servicios de representación e intermediación de deportistas profesionales',
  },
  {
    code: 749009,
    label: 'Actividades profesionales, científicas y técnicas n.c.p.',
  },
  {
    code: 750000,
    label: 'Servicios veterinarios',
  },
  {
    code: 771110,
    label: 'Alquiler de automóviles sin conductor',
  },
  {
    code: 771190,
    label:
      'Alquiler de vehículos automotores n.c.p., sin conductor ni operarios',
  },
  {
    code: 771210,
    label:
      'Alquiler de equipo de transporte para vía acuática, sin operarios ni tripulación',
  },
  {
    code: 771220,
    label:
      'Alquiler de equipo de transporte para vía aérea, sin operarios ni tripulación',
  },
  {
    code: 771290,
    label: 'Alquiler de equipo de transporte n.c.p. sin conductor ni operarios',
  },
  {
    code: 772010,
    label: 'Alquiler de videos y video juegos',
  },
  {
    code: 772091,
    label: 'Alquiler de prendas de vestir',
  },
  {
    code: 772099,
    label: 'Alquiler de efectos personales y enseres domésticos n.c.p.',
  },
  {
    code: 773010,
    label:
      'Alquiler de maquinaria y equipo agropecuario y forestal, sin operarios',
  },
  {
    code: 773020,
    label: 'Alquiler de maquinaria y equipo para la minería, sin operarios',
  },
  {
    code: 773030,
    label:
      'Alquiler de maquinaria y equipo de construcción e ingeniería civil, sin operarios',
  },
  {
    code: 773040,
    label: 'Alquiler de maquinaria y equipo de oficina, incluso computadoras',
  },
  {
    code: 773090,
    label: 'Alquiler de maquinaria y equipo n.c.p., sin personal',
  },
  {
    code: 774000,
    label: 'Arrendamiento y gestión de bienes intangibles no financieros',
  },
  {
    code: 780000,
    label: 'Obtención y dotación de personal',
  },
  {
    code: 791100,
    label: 'Servicios minoristas de agencias de viajes',
  },
  {
    code: 791200,
    label: 'Servicios mayoristas de agencias de viajes',
  },
  {
    code: 791901,
    label: 'Servicios de turismo aventura',
  },
  {
    code: 791909,
    label: 'Servicios complementarios de apoyo turístico n.c.p.',
  },
  {
    code: 801010,
    label: 'Servicios de transporte de caudales y objetos de valor',
  },
  {
    code: 801020,
    label: 'Servicios de sistemas de seguridad',
  },
  {
    code: 801090,
    label: 'Servicios de seguridad e investigación n.c.p.',
  },
  {
    code: 811000,
    label: 'Servicio combinado de apoyo a edificios',
  },
  {
    code: 812010,
    label: 'Servicios de limpieza general de edificios',
  },
  {
    code: 812020,
    label:
      'Servicios de desinfección y exterminio de plagas en el ámbito urbano',
  },
  {
    code: 812090,
    label: 'Servicios de limpieza n.c.p.',
  },
  {
    code: 813000,
    label: 'Servicios de jardinería y mantenimiento de espacios verdes',
  },
  {
    code: 821100,
    label: 'Servicios combinados de gestión administrativa de oficinas',
  },
  {
    code: 821900,
    label:
      'Servicios de fotocopiado, preparación de documentos y otros servicios de apoyo de oficina',
  },
  {
    code: 822000,
    label: 'Servicios de call center',
  },
  {
    code: 823000,
    label:
      'Servicios de organización de convenciones y exposiciones comerciales, excepto culturales y deportivos',
  },
  {
    code: 829100,
    label: 'Servicios de agencias de cobro y calificación crediticia',
  },
  {
    code: 829200,
    label: 'Servicios de envase y empaque',
  },
  {
    code: 829900,
    label: 'Servicios empresariales n.c.p.',
  },
  {
    code: 841100,
    label: 'Servicios generales de la Administración Pública',
  },
  {
    code: 841200,
    label:
      'Servicios para la regulación de las actividades sanitarias, educativas, culturales, y restantes servicios sociales, excepto seguridad social obligatoria',
  },
  {
    code: 841300,
    label: 'Servicios para la regulación de la actividad económica',
  },
  {
    code: 841900,
    label:
      'Servicios auxiliares para los servicios generales de la Administración Pública',
  },
  {
    code: 842100,
    label: 'Servicios de asuntos exteriores',
  },
  {
    code: 842200,
    label: 'Servicios de defensa',
  },
  {
    code: 842300,
    label: 'Servicios para el orden público y la seguridad',
  },
  {
    code: 842400,
    label: 'Servicios de justicia',
  },
  {
    code: 842500,
    label: 'Servicios de protección civil',
  },
  {
    code: 843000,
    label:
      'Servicios de la seguridad social obligatoria, excepto obras sociales',
  },
  {
    code: 851010,
    label: 'Guarderías y jardines maternales',
  },
  {
    code: 851020,
    label: 'Enseñanza inicial, jardín de infantes y primaria',
  },
  {
    code: 852100,
    label: 'Enseñanza secundaria de formación general',
  },
  {
    code: 852200,
    label: 'Enseñanza secundaria de formación técnica y profesional',
  },
  {
    code: 853100,
    label: 'Enseñanza  terciaria',
  },
  {
    code: 853201,
    label: 'Enseñanza universitaria excepto formación de posgrado',
  },
  {
    code: 853300,
    label: 'Formación de posgrado',
  },
  {
    code: 854910,
    label: 'Enseñanza de idiomas',
  },
  {
    code: 854920,
    label: 'Enseñanza de cursos relacionados con informática',
  },
  {
    code: 854930,
    label: 'Enseñanza para adultos, excepto discapacitados',
  },
  {
    code: 854940,
    label: 'Enseñanza especial y para discapacitados',
  },
  {
    code: 854950,
    label: 'Enseñanza de gimnasia, deportes y actividades físicas',
  },
  {
    code: 854960,
    label: 'Enseñanza artística',
  },
  {
    code: 854990,
    label: 'Servicios de enseñanza n.c.p.',
  },
  {
    code: 855000,
    label: 'Servicios de apoyo a la educación',
  },
  {
    code: 861010,
    label:
      'Servicios de internación excepto instituciones relacionadas con la salud mental',
  },
  {
    code: 861020,
    label:
      'Servicios de internación en instituciones relacionadas con la salud mental',
  },
  {
    code: 862110,
    label: 'Servicios de  consulta médica',
  },
  {
    code: 862120,
    label: 'Servicios de proveedores de atención médica domiciliaria',
  },
  {
    code: 862130,
    label:
      'Servicios de atención médica en dispensarios, salitas, vacunatorios y otros locales de atención primaria de la salud',
  },
  {
    code: 862200,
    label: 'Servicios odontológicos',
  },
  {
    code: 863110,
    label: 'Servicios de prácticas de diagnóstico en laboratorios',
  },
  {
    code: 863120,
    label: 'Servicios de prácticas de diagnóstico por imágenes',
  },
  {
    code: 863190,
    label: 'Servicios de prácticas de diagnóstico n.c.p.',
  },
  {
    code: 863200,
    label: 'Servicios de tratamiento',
  },
  {
    code: 863300,
    label: 'Servicio médico integrado de consulta, diagnóstico y tratamiento',
  },
  {
    code: 864000,
    label: 'Servicios de emergencias y traslados',
  },
  {
    code: 869010,
    label: 'Servicios de rehabilitación física',
  },
  {
    code: 869090,
    label: 'Servicios relacionados con la salud humana n.c.p.',
  },
  {
    code: 870100,
    label:
      'Servicios de atención a personas con problemas de salud mental o de adicciones, con alojamiento',
  },
  {
    code: 870210,
    label: 'Servicios de atención a ancianos con alojamiento',
  },
  {
    code: 870220,
    label: 'Servicios de atención a personas minusválidas con alojamiento',
  },
  {
    code: 870910,
    label:
      'Servicios de atención a niños y adolescentes carenciados con alojamiento',
  },
  {
    code: 870920,
    label: 'Servicios de atención a mujeres con alojamiento',
  },
  {
    code: 870990,
    label: 'Servicios sociales con alojamiento n.c.p.',
  },
  {
    code: 880000,
    label: 'Servicios sociales sin alojamiento',
  },
  {
    code: 900011,
    label: 'Producción de espectáculos teatrales y musicales',
  },
  {
    code: 900021,
    label:
      'Composición y representación de obras teatrales, musicales y artísticas',
  },
  {
    code: 900030,
    label:
      'Servicios conexos a la producción de espectáculos teatrales y musicales',
  },
  {
    code: 900040,
    label: 'Servicios de agencias de ventas de entradas',
  },
  {
    code: 900091,
    label: 'Servicios de espectáculos artísticos n.c.p.',
  },
  {
    code: 910100,
    label: 'Servicios de bibliotecas y archivos',
  },
  {
    code: 910200,
    label:
      'Servicios de museos y preservación de lugares y edificios históricos',
  },
  {
    code: 910300,
    label:
      'Servicios de jardines botánicos, zoológicos y de parques nacionales',
  },
  {
    code: 910900,
    label: 'Servicios culturales n.c.p.',
  },
  {
    code: 920001,
    label:
      'Servicios de recepción de apuestas de quiniela, lotería y similares',
  },
  {
    code: 920009,
    label: 'Servicios relacionados con juegos de azar y apuestas n.c.p.',
  },
  {
    code: 931010,
    label:
      'Servicios de organización, dirección y gestión de prácticas deportivas en clubes',
  },
  {
    code: 931020,
    label: 'Explotación de instalaciones deportivas, excepto clubes',
  },
  {
    code: 931030,
    label: 'Promoción y producción de espectáculos deportivos',
  },
  {
    code: 931041,
    label:
      'Servicios prestados por deportistas y atletas para la realización de prácticas deportivas',
  },
  {
    code: 931042,
    label:
      'Servicios prestados por profesionales y técnicos para la realización de prácticas deportivas',
  },
  {
    code: 931050,
    label: 'Servicios de acondicionamiento físico',
  },
  {
    code: 931090,
    label: 'Servicios para la práctica deportiva n.c.p.',
  },
  {
    code: 939010,
    label: 'Servicios de parques de diversiones y parques temáticos',
  },
  {
    code: 939020,
    label: 'Servicios de salones de juegos',
  },
  {
    code: 939030,
    label: 'Servicios de salones de baile, discotecas y similares',
  },
  {
    code: 939090,
    label: 'Servicios de entretenimiento n.c.p.',
  },
  {
    code: 941100,
    label: 'Servicios de organizaciones empresariales y de empleadores',
  },
  {
    code: 941200,
    label: 'Servicios de organizaciones profesionales',
  },
  {
    code: 942000,
    label: 'Servicios de sindicatos',
  },
  {
    code: 949100,
    label: 'Servicios de organizaciones religiosas',
  },
  {
    code: 949200,
    label: 'Servicios de organizaciones políticas',
  },
  {
    code: 949910,
    label: 'Servicios de mutuales, excepto mutuales de salud y financieras',
  },
  {
    code: 949920,
    label: 'Servicios de consorcios de edificios',
  },
  {
    code: 949930,
    label: 'Servicios de cooperativas cuando realizan varias actividades',
  },
  {
    code: 949990,
    label: 'Servicios de asociaciones n.c.p.',
  },
  {
    code: 951100,
    label: 'Reparación y mantenimiento de equipos informáticos',
  },
  {
    code: 951200,
    label:
      'Reparación y mantenimiento de equipos de telefonía y de comunicación',
  },
  {
    code: 952200,
    label: 'Reparación de calzado y artículos de marroquinería',
  },
  {
    code: 952300,
    label: 'Reparación de tapizados y muebles',
  },
  {
    code: 952910,
    label:
      'Reforma y reparación de cerraduras, duplicación de llaves. Cerrajerías',
  },
  {
    code: 952920,
    label: 'Reparación de relojes y joyas. Relojerías',
  },
  {
    code: 952990,
    label: 'Reparación de efectos personales y enseres domésticos n.c.p.',
  },
  {
    code: 960101,
    label: 'Servicios de limpieza de prendas prestado por tintorerías rápidas',
  },
  {
    code: 960102,
    label:
      'Lavado y limpieza de artículos de tela, cuero y/o de piel, incluso la limpieza en seco',
  },
  {
    code: 960201,
    label: 'Servicios de peluquería',
  },
  {
    code: 960202,
    label: 'Servicios de tratamiento de belleza, excepto los de peluquería',
  },
  {
    code: 960300,
    label: 'Pompas fúnebres y servicios conexos',
  },
  {
    code: 960910,
    label: 'Servicios de centros de estética, spa y similares',
  },
  {
    code: 960990,
    label: 'Servicios personales n.c.p.',
  },
  {
    code: 970000,
    label: 'Servicios de hogares privados que contratan servicio doméstico',
  },
  {
    code: 990000,
    label: 'Servicios de organizaciones y órganos extraterritoriales',
  },
  {
    code: 952100,
    label: 'Reparación de artículos eléctricos y electrónicos de uso doméstico',
  },
  {
    code: 476200,
    label: "Venta al por menor de CD's y DVD's de audio y video grabados",
  },
  {
    code: 464910,
    label: "Venta al por mayor de CD's y DVD's de audio y video grabados.",
  },
  {
    code: 461091,
    label:
      'Venta al por mayor en comisión o consignación de prod. textiles, prendas de vestir, calzado excepto el ortopédico, art.de marroquinería, paraguas y similares y prod.de cuero n.c.p',
  },
  {
    code: 431220,
    label:
      'Perforación y sondeo, excepto perforación de pozos de petróleo, de gas, de minas e hidráulicos  y prospección de yacimientos de petróleo',
  },
  {
    code: 331301,
    label:
      'Reparación y mantenimiento de instrumentos médicos,ópticos y de precisión,equipo fotográfico,aparatos para medir,ensayar o navegar,relojes,excepto para uso personal o doméstico',
  },
  {
    code: 14221,
    label: 'Cría de ganado equino realizada en haras',
  },
  {
    code: 7,
    label: 'Jubilado',
  },
  {
    code: 8,
    label: 'Estudiante',
  },
  {
    code: 9,
    label: 'Ama de casa',
  },
  {
    code: 10,
    label: 'Ex - Agente de la Adm. Publica',
  },
  {
    code: 11,
    label: 'Trabajo Relac. Dependencia',
  },
  {
    code: 12,
    label: 'Sin Actividad Economica',
  },
  {
    code: 13,
    label: 'Agricultura Familiar',
  },
];
